<template>
    <v-layout class="column" :class="{'pa-3': $vuetify.breakpoint.smAndDown, 'pa-4 ': $vuetify.breakpoint.mdAndUp}">
        <router-link :to="{name:'idea_detail', params: {id: content.id}}" class="link link--dark link--no-decor">
            <div :class="{'mb-2': $vuetify.breakpoint.smAndDown, 'title': $vuetify.breakpoint.smAndUp}">{{ content.title }}</div>
        </router-link>
        <v-layout row wrap align-center
                  mt-4
        >
            <v-flex pr-4 md2 xs7>
                <v-layout>
                    <div class="mr-2">{{ day(content.date) }}</div>
                    <div class="grey-text">{{ time(content.date) }}</div>
                </v-layout>
            </v-flex>
            <v-flex v-if="$vuetify.breakpoint.mdAndUp" align-center md4
                    xl5
            >
                <iconLabel icon_name="idea" class="grey-text" size="20">{{ content.theme }}</iconLabel>
            </v-flex>
        </v-layout>
        <div v-if="$vuetify.breakpoint.smAndUp" class="mt-3 grey-text">{{ content.text }}</div>
    </v-layout>
</template>

<script>
import iconLabel from '@/components/ui/icons/icon_with_label';
import dayjs from 'dayjs';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import utc from 'dayjs-plugin-utc';

dayjs.extend(utc);
export default {
  components: {
    iconLabel,
  },
  props: {
    content: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
  },
  methods: {
    day(date) {
      return new dayjs(date).utc().format('DD.MM.YYYY');
    },
    time(date) {
      return new dayjs(date).utc().format('HH.MM');
    },
  },

};
</script>
